import script from "./ImageUploadPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageUploadPreview.vue?vue&type=script&setup=true&lang=js"

import "./ImageUploadPreview.vue?vue&type=style&index=0&id=f655cc0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f655cc0e"]])

export default __exports__